import type { StatusPillTone } from './StatusPill';

const NOA_STATUS_TONES: Record<string, StatusPillTone> = {
  accepted: 'success',
  paid: 'success',
  rejected: 'danger',
  sent: 'info',
  acknowledged: 'info',
  not_ready: 'neutral',
  ready_to_send: 'neutral',
  not_applicable: 'neutral',
};

/** Maps an NOA status to its `StatusPill` tone; unknown statuses are neutral. */
export function getNoaStatusTone(status: string): StatusPillTone {
  return NOA_STATUS_TONES[status] ?? 'neutral';
}
